import { useEffect, useLayoutEffect, useRef } from 'react';

const CLOSE_ON_BACK_STATE_KEY = 'closeOnBack';

let nextEntryId = 0;
let pendingSelfPops = 0;
let landingIsSelfPop = false;

window.addEventListener('popstate', () => {
    landingIsSelfPop = pendingSelfPops > 0;
    if (landingIsSelfPop) pendingSelfPops -= 1;
});

const currentEntryId = () => window.history.state?.[CLOSE_ON_BACK_STATE_KEY];

const buildEntryState = (entryId: number, replace = false) => {
    const prev = window.history.state ?? {};
    return {
        ...prev,
        usr: prev.usr ?? null,
        key: Math.random().toString(36).slice(2, 10),
        idx: typeof prev.idx === 'number' && !replace ? prev.idx + 1 : prev.idx,
        [CLOSE_ON_BACK_STATE_KEY]: entryId,
    };
};

export function useCloseOnBack(active: boolean, onClose: () => void) {
    const onCloseRef = useRef(onClose);
    useLayoutEffect(() => {
        onCloseRef.current = onClose;
    });

    useEffect(() => {
        if (!active) return undefined;
        nextEntryId += 1;
        const entryId = nextEntryId;
        let closedByBack = false;
        window.history.pushState(buildEntryState(entryId), '');
        const handlePopState = () => {
            if (landingIsSelfPop) {
                if (currentEntryId() !== entryId) window.history.replaceState(buildEntryState(entryId, true), '');
                return;
            }
            if (currentEntryId() === entryId) return;
            closedByBack = true;
            onCloseRef.current();
        };
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
            if (closedByBack || currentEntryId() !== entryId) return;
            pendingSelfPops += 1;
            window.history.back();
        };
    }, [active]);
}
